class LanguageModal extends DetailsModal {
	constructor() {
		super();
		this.currentCountryIsoCode = this.querySelector('[data-country-code]')?.dataset.countryCode;
		this.currentCountryNameEl = this.querySelector('[data-country-name]');
		this.languagesElements = this.querySelectorAll('.language-item');
		this.closeButton = this.querySelector('[data-close-custom]');
		this.updateLanguageLinks();
		if(window.Shopify?.designMode) return;
		this.init();
	}

	async init() {
		await this.fetchData();

		if (!this.currentCountryIsoCode) return;
		if (document.cookie.includes(`lang_suggest=${this.currentCountryIsoCode}`)) return;

		const langConfig = this.getConfig();

		if (!langConfig?.domains) return;

		const match = this.findSuggestedDomain(langConfig);
		if (!match) return;

		const currentHost = String(langConfig.currentHost || location.hostname).toLowerCase().replace(/^www\./, '');
		const [suggestHost, langList] = match;
		if (suggestHost === currentHost) return;

		this.open();
		this.filterLanguageOptions(langList)

		this.closeEventListener();
	}

	async fetchData() {
		try {
			const response = await fetch(
				window.Shopify.routes.root +
				'browsing_context_suggestions.json' +
				'?country[enabled]=true' +
				`&country[exclude]=${window.Shopify.country}` +
				'&language[enabled]=true' +
				`&language[exclude]=${window.Shopify.language}`
			);

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const data = await response.json();
			const apiCountry =
				data?.detected_values?.country?.handle ||
				data?.suggestions?.[0]?.parts?.country?.handle ||
				null;
			if (apiCountry) {
				this.currentCountryIsoCode = String(apiCountry).toUpperCase();
			}

			const apiCountryName =
				data?.detected_values?.country?.name ||
				data?.suggestions?.[0]?.parts?.country?.name ||
				null;

			if (apiCountryName && this.currentCountryNameEl) {
				this.currentCountryNameEl.textContent = apiCountryName;
			}

		} catch (error) {
			console.error('Error fetching data:', error);
		}
	}

	getConfig() {
		const cfgEl = document.getElementById('language-config');
		if (!cfgEl) return null;

		try {
			return JSON.parse(cfgEl.textContent);
		} catch {
			return null;
		}
	}
	updateLanguageLinks() {
		const alternatesElements = document.querySelectorAll('link[rel="alternate"][hreflang]');
		if (alternatesElements.length === 0) return;

		const alternates = Array.from(alternatesElements).map(el => {
			try {
				const url = new URL(el.href, window.location.origin);
				
				return {
					lang: el.getAttribute('hreflang').toLowerCase(),
					href: el.href,
					host: url.hostname.replace(/^www\./, '')
				};
			} catch (e) { return null; }
		}).filter(Boolean);

		document.querySelectorAll('.language-item[data-iso-code]').forEach((item) => {
			const isoCode = item.getAttribute('data-iso-code')?.toLowerCase();
			if (!isoCode) return;

			let targetHost = null;
			const targetLink = item.getAttribute('data-link');
			if (targetLink) {
				try {
					targetHost = new URL(targetLink).hostname.replace(/^www\./, '');
				} catch (e) { /* ignore */ }
			}

			const alternate =
				alternates.find(a => (a.lang === isoCode || a.lang.startsWith(`${isoCode}-`)) && a.host === targetHost) ||
				alternates.find(a => a.lang === isoCode) ||
				alternates.find(a => a.lang.startsWith(`${isoCode}-`));

			if (alternate) {
				const link = item.querySelector('a.language-item__link');
				if (link) link.href = alternate.href;
			}
		});
	}

	findSuggestedDomain(langConfig) {
		const entries = Object.entries(langConfig?.domains);
		return entries?.find(([, list]) => list.includes(this.currentCountryIsoCode));
	}

	filterLanguageOptions(langList) {
		this.languagesElements.forEach(languageElement => {
			const isoCode = languageElement.getAttribute('data-iso-code');
			!langList.includes(isoCode) ? languageElement.remove() : null;

			languageElement.addEventListener('click', () => {
				this.setCookieItem('lang_suggest', this.currentCountryIsoCode, 30);
			});
		});
	}

	open(event) {
		this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
		const details = event?.target?.closest('details') || this.detailsContainer;

		details.setAttribute('open', true);
		document.body.addEventListener('click', this.onBodyClickEvent);
		document.body.classList.add('overflow-hidden');

		trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'));
	}

	close(focusToggle = true) {
		this.setCookieItem('lang_suggest', this.currentCountryIsoCode, 30);

		super.close(focusToggle);
	}

	onBodyClick() {}

	closeEventListener() {
		this.closeButton?.addEventListener('click', () => this.close());
	}

	setCookieItem(key, value, expirationDays) {
		const date = new Date();
		date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);

		const secure = location.protocol === "https:" ? "; Secure" : "";

		document.cookie = `${key}=${value};Expires=${date.toUTCString()};Path=/;SameSite=Lax;${secure}`;
	}
}

customElements.define('language-modal', LanguageModal);
